import * as React from 'react'
import * as THREE from 'three'
import * as datGui from 'dat.gui'
import Stage from 'components/Designer/Stage'

interface Props {
  enableHelpers?: Boolean
}

interface State {}

class DefaultLights extends React.Component<Props, State> {
  private datGui: datGui.GUI | undefined
  private lights: THREE.Light[] = []
  private helpers: THREE.Object3D[] = []
  private enableHelpers: Boolean = false

  constructor(props: Props) {
    super(props)
    if (props.enableHelpers) {
      this.enableHelpers = props.enableHelpers
    }
  }

  render() {
    return null
  }

  componentDidMount() {
    const stage = Stage.getInstance()
    const DGInst = Stage.datgui
    const datGuiFolder = DGInst.addFolder('Lights')
    this.datGui = datGuiFolder

    const lghtPntTop = new THREE.PointLight('#ffffff', 180)
    const lghtPntTopHlpr = new THREE.PointLightHelper(lghtPntTop, 1)
    lghtPntTop.position.set(0, 100, 0)
    this.lights.push(lghtPntTop)
    this.helpers.push(lghtPntTopHlpr)
    const lghtPntTpFldr = datGuiFolder.addFolder('Light Point Top')
    lghtPntTpFldr.add(lghtPntTop, 'intensity', 0, 500, 1).onChange(e => {
      lghtPntTop.intensity = e
      stage.update()
    })

    const lghtHmsTop = new THREE.HemisphereLight('#ffffff', '#000000', 0.5)
    lghtHmsTop.position.set(0, 1, 0)
    this.lights.push(lghtHmsTop)
    const lghtHmsFldr = datGuiFolder.addFolder('Light Hemesphere Top')
    lghtHmsFldr.add(lghtHmsTop, 'intensity', 0, 5, 0.1).onChange(e => {
      lghtHmsTop.intensity = e
      stage.update()
    })

    const lghtPntLft = new THREE.PointLight('#ffffff', 150)
    const lghtPntLftHlpr = new THREE.PointLightHelper(lghtPntLft, 1)
    lghtPntLft.position.set(-100, 100, 100)
    this.lights.push(lghtPntLft)
    this.helpers.push(lghtPntLftHlpr)
    const lghtPntLftFldr = datGuiFolder.addFolder('Light Point Left')
    lghtPntLftFldr.add(lghtPntLft, 'intensity', 0, 500, 1).onChange(e => {
      lghtPntLft.intensity = e
      stage.update()
    })
    lghtPntLftFldr.add(lghtPntLft.position, 'x', -200, 200, 1).onChange(e => {
      lghtPntLft.position.x = e
      stage.update()
    })
    lghtPntLftFldr.add(lghtPntLft.position, 'y', 0, 200, 1).onChange(e => {
      lghtPntLft.position.y = e
      stage.update()
    })
    lghtPntLftFldr.add(lghtPntLft.position, 'z', -200, 200, 1).onChange(e => {
      lghtPntLft.position.z = e
      stage.update()
    })

    const lghtPntRght = new THREE.PointLight('#ffffff', 150)
    const lghtPntRghtHlpr = new THREE.PointLightHelper(lghtPntRght, 1)
    lghtPntRght.position.set(100, 50, 100)
    this.lights.push(lghtPntRght)
    this.helpers.push(lghtPntRghtHlpr)
    const lghtPntRghtFldr = datGuiFolder.addFolder('Light Point Right')
    lghtPntRghtFldr.add(lghtPntRght, 'intensity', 0, 500, 1).onChange(e => {
      lghtPntRght.intensity = e
      stage.update()
    })
    lghtPntRghtFldr.add(lghtPntRght.position, 'x', -200, 200, 1).onChange(e => {
      lghtPntRght.position.x = e
      stage.update()
    })
    lghtPntRghtFldr.add(lghtPntRght.position, 'y', 0, 200, 1).onChange(e => {
      lghtPntRght.position.y = e
      stage.update()
    })
    lghtPntRghtFldr.add(lghtPntRght.position, 'z', -200, 200, 1).onChange(e => {
      lghtPntRght.position.z = e
      stage.update()
    })

    const lghtPntRghtBck = new THREE.PointLight('#ffffff', 180)
    const lghtPntRghtBckHlpr = new THREE.PointLightHelper(lghtPntRghtBck, 1)
    lghtPntRghtBck.position.set(100, 100, -100)
    this.lights.push(lghtPntRghtBck)
    this.helpers.push(lghtPntRghtBckHlpr)
    const lghtPntRghtBckFldr = datGuiFolder.addFolder('Light Point Right Back')
    lghtPntRghtBckFldr
      .add(lghtPntRghtBck, 'intensity', 0, 500, 1)
      .onChange(e => {
        lghtPntRghtBck.intensity = e
        stage.update()
      })
    lghtPntRghtBckFldr
      .add(lghtPntRghtBck.position, 'x', -200, 200, 1)
      .onChange(e => {
        lghtPntRghtBck.position.x = e
        stage.update()
      })
    lghtPntRghtBckFldr
      .add(lghtPntRghtBck.position, 'y', 0, 200, 1)
      .onChange(e => {
        lghtPntRghtBck.position.y = e
        stage.update()
      })
    lghtPntRghtBckFldr
      .add(lghtPntRghtBck.position, 'z', -200, 200, 1)
      .onChange(e => {
        lghtPntRghtBck.position.z = e
        stage.update()
      })

    const lghtPntLftBck = new THREE.PointLight('#ffffff', 180)
    const lghtPntLftBckHlpr = new THREE.PointLightHelper(lghtPntLftBck, 1)
    lghtPntLftBck.position.set(-100, 50, -100)
    this.lights.push(lghtPntLftBck)
    this.helpers.push(lghtPntLftBckHlpr)
    const lghtPntLftBckFldr = datGuiFolder.addFolder('Light Point Left Back')
    lghtPntLftBckFldr.add(lghtPntLftBck, 'intensity', 0, 500, 1).onChange(e => {
      lghtPntLftBck.intensity = e
      stage.update()
    })
    lghtPntLftBckFldr
      .add(lghtPntLftBck.position, 'x', -200, 200, 1)
      .onChange(e => {
        lghtPntLftBck.position.x = e
        stage.update()
      })
    lghtPntLftBckFldr
      .add(lghtPntLftBck.position, 'y', 0, 200, 1)
      .onChange(e => {
        lghtPntLftBck.position.y = e
        stage.update()
      })
    lghtPntLftBckFldr
      .add(lghtPntLftBck.position, 'z', -200, 200, 1)
      .onChange(e => {
        lghtPntLftBck.position.z = e
        stage.update()
      })

    Stage.scene.add(...this.lights)
    if (this.enableHelpers) {
      Stage.scene.add(...this.helpers)
    }
  }

  componentWillUnmount() {
    Stage.scene.remove(...this.lights)

    if (this.enableHelpers) {
      Stage.scene.remove(...this.helpers)
    }

    if (this.datGui) {
      Stage.datgui.removeFolder(this.datGui)
    }
  }
}

export default DefaultLights
